import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {forkJoin, Observable} from 'rxjs';
import { DashboardSelection } from 'src/app/models/dashboard-selection.model';
import { ScreenSize } from 'src/app/models/screen-size.model';
import { MobileCheck } from 'src/app/services/mobile-check/mobile-check.service';
import { ColorDashboard } from '../../models/color-dashboard.model';
import * as fromRoot from '../../reducers';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import {AlertUserConfig} from '../../models/alert-user-config';
import {NotificationService} from '../../services/notification/notification.service';
import {Iproject} from "../../models/project.model";
import {IBatch} from "../../models/batch.model";
import {AuthenticationService, DecodedJwt} from "@colimo/colimo-ui-library";
import {take} from "rxjs/operators";
import {AlertUserStatus} from "../../models/alert-user-status";
import {MatCard} from "@angular/material/card";
import {PageHeaderComponent} from "../../shared/components/page-header/page-header.component";
import {MatExpansionPanel, MatExpansionPanelContent,  MatExpansionPanelHeader,MatExpansionPanelDescription, MatExpansionPanelTitle} from "@angular/material/expansion";
import {AsyncPipe, NgClass} from "@angular/common";
import {CustomerCardsComponent} from "../customer-cards/customer-cards.component";
import {WarningsCountPipe} from "../../pipes/warnings-count/warnings-count.pipe";
import {ProductCountPipe} from "../../pipes/product-count/product-count.pipe";
import {TranslateModule} from "@ngx-translate/core";
import {AlertMaxLevelPipe} from "../../pipes/alert-max-level/alert-max-level.pipe";
import {ArrayToPipeListPipe} from "../../pipes/array-to-pipe-list/array-to-pipe-list.pipe";
import {MatIcon} from "@angular/material/icon";
import {LoaderComponent} from "../../shared/components/loader/loader.component";
import {RouterLink} from "@angular/router";
import {ColorCardComponent} from "../../components/color-card/color-card.component";

@Component({
  selector: 'colimo-color-dashboard',
  providers: [DashboardService],
  templateUrl: 'color-dashboard.component.html',
  styleUrls: ['color-dashboard.component.scss'],
  imports: [
    MatCard,
    PageHeaderComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelContent,
    NgClass,
    MatExpansionPanelTitle,
    CustomerCardsComponent,
    MatExpansionPanelDescription,
    MatIcon,
    WarningsCountPipe,
    ProductCountPipe,
    TranslateModule,
    AlertMaxLevelPipe,
    ArrayToPipeListPipe,
    AsyncPipe,
    LoaderComponent,
    RouterLink,
    ColorCardComponent
  ]
})
export class ColorDashboardComponent implements OnInit {
  public heading: string;
  public isLoading = true;
  public dashboard$: Observable<ColorDashboard[]>;
  public dashboardSelection$: Observable<DashboardSelection>;
  public isMobile$: Observable<ScreenSize>;
  public alertsConfigured: boolean;

  private userId: string;

  constructor(
    private dashboardService: DashboardService,
    private store: Store<fromRoot.State>,
    private mobileCheck: MobileCheck,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService
  ) {}

  public ngOnInit(): void {
    this.heading = 'reports.reportTable.color';
    this.dashboardService.getColorDashboard().subscribe(() => {
      this.isLoading = false;
    });
    this.dashboard$ = this.store.select(fromRoot.getColorDashboard);
    this.dashboardSelection$ = this.store.select(fromRoot.getDashboardSelection);
    this.isMobile$ = this.mobileCheck.getScreenSize();
    this.notificationService.getAlertUserConfigObservable().subscribe({
      next: (config: AlertUserConfig) => {
        this.alertsConfigured = this.notificationService.alertsConfigured(config);
      }
    });
    // #441303 start notification/alert polling with service was moved to sidenav component in order to handle page refreshes
    //this.notificationService.startPolling();

    this.authenticationService.authentication.pipe(take(1)).subscribe({next: (decodedToken: DecodedJwt) => {
      this.userId = decodedToken.sub;
    }});
  }

  public customerSelected(newCustomer: string, storedCustomer: string): void {
    if (newCustomer === storedCustomer) {
      this.dashboardService.setCurrentDashboardSelection({ customer: null, line: null, model: null });
    } else {
      this.dashboardService.setCurrentDashboardSelection({
        customer: newCustomer,
        line: null,
        model: null,
      });
    }
  }

  public colorCardSelected(project: Iproject): void {
    if (!project || !project.products) {
      return;
    }
    // get possible new batches that are displayed the first time (user specific green dot)
    const newBatches: IBatch[] = []
    for (let i = 0; i < project.products.length; i++) {
      if (!project.products[i].batches) {
        continue;
      }
      newBatches.push(...project.products[i].batches.filter((batch) => { return batch.newBatchAlertId && batch.state === 'IN_LINE' }));
    }
    // update status of new batches alert to deleted (status = 2) ==> green dot should not be displayed the next time for the user
    if (newBatches.length > 0) {
      const observablesAlertStatus: Observable<AlertUserStatus>[] = [];
      for (let j = 0; j < newBatches.length; j++) {
        const newBatchReadStatus: AlertUserStatus = { userId: this.userId, status: 2, alertId: newBatches[j].newBatchAlertId };
        observablesAlertStatus.push(this.notificationService.updateAlertStatus(newBatchReadStatus));
      }
      forkJoin(observablesAlertStatus).pipe(take(1)).subscribe({
        next: (updatesStatusArray: AlertUserStatus[]) => {
          // nothing
        },
        error: () => {
          // nothing
        }
      });
    }
  }
}
